<template>
  <div>
    <div class="section_menu">
      <router-link to="/backoffice/bypass/passadd">
        <span>Добавление пропуска</span>
      </router-link>
      <!--<router-link to="/backoffice/bypass/rfidadd">
        <span>Добавление RFID</span>
      </router-link>-->
      <router-link to="/backoffice/bypass/autoadd">
        <span>Добавление пропуска в Парсек</span>
      </router-link>
      <!--<router-link to="/backoffice/bypass/qradd">
        <span>Добавление QR</span>
      </router-link>-->
      <router-link to="/backoffice/bypass/doorcontrol">
        <span>Управление шлагбаумами</span>
      </router-link>
      <router-link to="/backoffice/bypass/paintaccessline">
        <span>Карта диспетчера</span>
      </router-link>
      <router-link to="/backoffice/bypass/useaccessline">
        <span>Кабинет диспетчера</span>
      </router-link>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "BypassAdmin",

  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
